import type { MerchantApiClient } from "../../types.js";
import {
  MERCHANT_OPERATIONS,
  type FeedbackDto,
  type FeedbackReplyDto,
  type FeedbackPage,
} from "@price-rescue/api-contracts";
interface Envelope<T> {
  data: T;
}
export function createFeedbackApi(client: MerchantApiClient) {
  return {
    async list(cursor?: string): Promise<FeedbackPage> {
      return (
        await client.operation<Envelope<FeedbackPage>>(MERCHANT_OPERATIONS.listMerchantFeedback, {
          query: { cursor, limit: 10 },
        })
      ).data;
    },
    async create(title: string, message: string): Promise<FeedbackDto> {
      return (
        await client.operation<Envelope<FeedbackDto>>(MERCHANT_OPERATIONS.createMerchantFeedback, {
          body: { title, message },
        })
      ).data;
    },
    async replies(feedbackId: string, cursor?: string): Promise<FeedbackPage<FeedbackReplyDto>> {
      return (
        await client.operation<Envelope<FeedbackPage<FeedbackReplyDto>>>(
          MERCHANT_OPERATIONS.listMerchantFeedbackReplies,
          { pathParams: { feedbackId }, query: { cursor, limit: 50 } },
        )
      ).data;
    },
    async reply(feedbackId: string, message: string): Promise<FeedbackReplyDto> {
      return (
        await client.operation<Envelope<FeedbackReplyDto>>(
          MERCHANT_OPERATIONS.createMerchantFeedbackReply,
          { pathParams: { feedbackId }, body: { message } },
        )
      ).data;
    },
  };
}
export type FeedbackApi = ReturnType<typeof createFeedbackApi>;
